export const toFixedAmount = (value) => value.toFixed(2);
